import AbstractEditWidget from "../../../cluetrainer/ui/widgets/AbstractEditWidget";
import { observe } from "../../reactive";
export default class NumberSlider extends AbstractEditWidget {
    constructor(min, max, step = 1) {
        super();
        this.min = min;
        this.max = max;
        this.step = step;
        this.enabled = observe(true);
        this.preview_function = v => v.toString();
        this.css("display", "flex").css("flex-grow", 1);
        this.append(this.input = c(`<input style="flex-grow: 1" type='range' min='${min}' max="${max}" step="${step}">`)
            .on("input", () => {
            this.commit(Number(this.input.container.val()));
            this.updatePreview();
        }), this.preview_container = c().css("min-width", "30px").css("margin-left", "3px"));
        this.enabled.subscribe(v => this.input.setProperty("disabled", !v));
    }
    modifyPreviewContainer(f) {
        f(this.preview_container);
        return this;
    }
    setEnabled(v) {
        this.enabled.set(v);
        return this;
    }
    withPreviewFunction(f) {
        this.preview_function = f;
        this.updatePreview();
        return this;
    }
    updatePreview() {
        let res = "";
        try {
            res = this.preview_function(this.get());
        }
        catch (e) { }
        if (!res)
            res = this.get()?.toString() || "0";
        this.preview_container.text(res);
    }
    render() {
        this.updatePreview();
        this.input.container.val(this.get());
    }
}
